export const VEHICLES_NUM_TO_RANK = 3;
export const ELECTRIC_SUBSEGMENT = 'Electric';

export const TYPE_JELLYBEANS = {
  suv: {
    url: '/suv/',
    name: 'SUV',
    alt: 'go to SUV type page',
  },
  sedan: {
    url: '/sedan/',
    name: 'Sedan',
    alt: 'go to Sedan type page',
  },
  coupe: {
    url: '/coupe/',
    name: 'Coupe',
    alt: 'go to Coupe type page',
  },
  hatchback: {
    url: '/hatchback/',
    name: 'Hatchback',
    alt: 'go to Hatchback type page',
  },
  truck: {
    url: '/truck/',
    name: 'Truck',
    alt: 'go to Truck type page',
  },
  wagon: {
    url: '/wagon/',
    name: 'Wagon',
    alt: 'go to Wagon type page',
  },
  convertible: {
    url: '/convertible/',
    name: 'Convertible',
    alt: 'go to Convertible type page',
  },
  minivan: {
    url: '/minivan/',
    name: 'Minivan',
    alt: 'go to Minivan type page',
  },
  electric: {
    url: '/electric-car',
    name: 'Electric',
    alt: 'go to Electric type page',
  },
  hybrid: {
    url: '/hybrid/',
    name: 'Hybrid',
    alt: 'go to Hybrid type page',
  },
};

export const REPLACE_WITH_IMAGE = {
  'chevrolet/trailblazer/2025':
    'chevrolet/trailblazer/2025/oem/2025_chevrolet_trailblazer_4dr-suv_activ_fq_oem_1_600.jpg',
  'mazda/cx-30/2025': 'mazda/cx-30/2025/oem/2025_mazda_cx-30_4dr-suv_25-s-carbon-edition_fq_oem_1_600.jpg',
  'buick/encore-gx/2025': 'buick/encore-gx/2025/oem/2025_buick_encore-gx_4dr-suv_avenir_fq_oem_1_600.jpg',
  'mazda/cx-50/2025': 'mazda/cx-50/2025/oem/2025_mazda_cx-50_4dr-suv_25-turbo-meridian-edition_fq_oem_1_600.jpg',
  'honda/cr-v/2025': 'honda/cr-v/2025/oem/2025_honda_cr-v_4dr-suv_ex-l_fq_oem_1_600.jpg',
  'mazda/cx-5/2025': 'mazda/cx-5/2025/oem/2025_mazda_cx-5_4dr-suv_25-carbon-turbo_fq_oem_1_600.jpg',
  'kia/sorento/2025': 'kia/sorento/2025/oem/2025_kia_sorento_4dr-suv_x-line-sx-prestige_fq_oem_1_600.jpg',
  'hyundai/santa-fe/2025': 'hyundai/santa-fe/2025/oem/2025_hyundai_santa-fe_4dr-suv_calligraphy_fq_oem_1_600.jpg',
  'mitsubishi/outlander/2024': 'mitsubishi/outlander/2023/oem/2023_mitsubishi_outlander_4dr-suv_se_fq_oem_1_600.jpg',
  'honda/passport/2025': 'honda/passport/2025/oem/2025_honda_passport_4dr-suv_black-edition_fq_oem_1_600.jpg',
  'toyota/land-cruiser/2025': 'toyota/land-cruiser/2025/oem/2025_toyota_land-cruiser_4dr-suv_1958_fq_oem_1_600.jpg',
  'jeep/grand-cherokee/2025': 'jeep/grand-cherokee/2025/oem/2025_jeep_grand-cherokee_4dr-suv_overland_fq_oem_1_600.jpg',
  'kia/telluride/2025': 'kia/telluride/2025/oem/2025_kia_telluride_4dr-suv_sx-prestige-x-pro_fq_oem_1_600.jpg',
  'hyundai/palisade/2025': 'hyundai/palisade/2025/oem/2025_hyundai_palisade_4dr-suv_calligraphy_fq_oem_1_600.jpg',
  'toyota/grand-highlander-hybrid/2025':
    'toyota/grand-highlander-hybrid/2025/oem/2025_toyota_grand-highlander-hybrid_4dr-suv_max-limited_fq_oem_3_600.jpg',
  'toyota/grand-highlander/2024':
    'toyota/grand-highlander/2024/oem/2024_toyota_grand-highlander_4dr-suv_platinum_fq_oem_1_600.jpg',
  'gmc/yukon/2024': 'gmc/yukon/2023/oem/2023_gmc_yukon_4dr-suv_at4_fq_oem_1_600.jpg',
  'chevrolet/suburban/2025':
    'chevrolet/suburban/2025/oem/2025_chevrolet_suburban_4dr-suv_high-country_fq_oem_3_600.jpg',
  'ford/expedition/2024': 'ford/expedition/2022/oem/2022_ford_expedition_4dr-suv_limited_fq_oem_1_600.jpg',
  'bmw/x1/2025': 'bmw/x1/2025/oem/2025_bmw_x1_4dr-suv_m35i_fq_oem_1_600.jpg',
  'mercedes-benz/glb-class/2025':
    'mercedes-benz/glb-class/2025/oem/2025_mercedes-benz_glb-class_4dr-suv_amg-glb-35_fq_oem_1_600.jpg',
  'mercedes-benz/gla-class/2025':
    'mercedes-benz/gla-class/2025/oem/2025_mercedes-benz_gla-class_4dr-suv_amg-gla-35_fq_oem_1_600.jpg',
  'genesis/gv70/2025': 'genesis/gv70/2025/oem/2025_genesis_gv70_4dr-suv_35t-sport_fq_oem_1_600.jpg',
  'mercedes-benz/glc-class/2025':
    'mercedes-benz/glc-class/2025/oem/2025_mercedes-benz_glc-class_4dr-suv_amg-glc-43_fq_oem_1_600.jpg',
  'acura/rdx/2025': 'acura/rdx/2025/oem/2025_acura_rdx_4dr-suv_base_fq_oem_1_600.jpg',
  'mercedes-benz/gle-class/2025':
    'mercedes-benz/gle-class/2025/oem/2025_mercedes-benz_gle-class_4dr-suv_amg-gle-53_fq_oem_1_600.jpg',
  'porsche/cayenne/2025': 'porsche/cayenne/2025/oem/2025_porsche_cayenne_4dr-suv_base_fq_oem_2_600.jpg',
  'genesis/gv80-coupe/2025':
    'genesis/gv80-coupe/2025/oem/2025_genesis_gv80-coupe_4dr-suv_35t-e-supercharger_fq_oem_1_600.jpg',
  'lexus/gx/2025': 'lexus/gx/2025/oem/2025_lexus_gx_4dr-suv_550-luxuryplus_fq_oem_1_600.jpg',
  'audi/q7/2025': 'audi/q7/2025/oem/2025_audi_q7_4dr-suv_prestige_fq_oem_1_600.jpg',
  'acura/mdx/2025': 'acura/mdx/2025/oem/2025_acura_mdx_4dr-suv_base_fq_oem_2_600.jpg',
  'mercedes-benz/gls-class/2025':
    'mercedes-benz/gls-class/2025/oem/2025_mercedes-benz_gls-class_4dr-suv_amg-gls-63_fq_oem_1_600.jpg',
  'lincoln/navigator/2024': 'lincoln/navigator/2022/oem/2022_lincoln_navigator_4dr-suv_black-label_fq_oem_1_600.jpg',
  'bmw/x7/2025': 'bmw/x7/2025/oem/2025_bmw_x7_4dr-suv_m60i_fq_oem_1_600.jpg',
  'mercedes-benz/maybach-gls/2025':
    'mercedes-benz/maybach-gls/2025/oem/2025_mercedes-benz_maybach-gls_4dr-suv_gls-600_fq_oem_1_600.jpg',
  'bentley/bentayga/2024': 'bentley/bentayga/2024/oem/2024_bentley_bentayga_4dr-suv_a-v8_fq_oem_1_600.jpg',
  'land-rover/range-rover/2025':
    'land-rover/range-rover/2025/oem/2025_land-rover_range-rover_4dr-suv_p530-autobiography_fq_oem_1_600.jpg',
  'tesla/model-y/2025': 'tesla/model-y/2025/oem/2025_tesla_model-y_4dr-suv_performance_fq_oem_1_600.jpg',
  'audi/sq5/2025': 'audi/sq5/2023/oem/2023_audi_sq5_4dr-suv_prestige_fq_oem_1_600.jpg',
  'audi/sq5-sportback/2025': 'audi/sq5-sportback/2023/oem/2023_audi_sq5-sportback_4dr-suv_prestige_fq_oem_1_600.jpg',
  'porsche/cayenne-coupe/2025/turbo-gt':
    'porsche/cayenne-coupe/2025/oem/2025_porsche_cayenne-coupe_4dr-suv_turbo-gt_fq_oem_1_600.jpg',
  'lamborghini/urus/2024': 'lamborghini/urus/2024/fe/2024_lamborghini_urus_f34_fe_1213221_600.jpg',
  'audi/sq7/2025': 'audi/sq7/2025/oem/2025_audi_sq7_4dr-suv_prestige_fq_oem_1_600.jpg',
  'mercedes-benz/gls-class/2025/amg-gls-63':
    'mercedes-benz/gls-class/2025/oem/2025_mercedes-benz_gls-class_4dr-suv_amg-gls-63_fq_oem_1_600.jpg',
  'bmw/alpina-xb7/2025': 'bmw/alpina-xb7/2025/oem/2025_bmw_alpina-xb7_4dr-suv_base_fq_oem_1_600.jpg',
  'cadillac/escalade/2024/v': 'cadillac/escalade/2024/oem/2024_cadillac_escalade_4dr-suv_v_fq_oem_1_600.jpg',
  'ford/mustang/2025/dark-horse': 'ford/mustang/2025/oem/2025_ford_mustang_coupe_dark-horse_fq_oem_1_600.jpg',
  'ford/mustang/2025': 'ford/mustang/2025/oem/2025_ford_mustang_coupe_ecoboost-premium_fq_oem_2_600.jpg',
  'ford/mustang/2025/coupe': 'ford/mustang/2025/oem/2025_ford_mustang_coupe_ecoboost-premium_fq_oem_2_600.jpg',
  'chevrolet/camaro/2024/coupe': 'chevrolet/camaro/2024/oem/2024_chevrolet_camaro_coupe_2ss_fq_oem_1_600.jpg',
  'dodge/charger/2025': 'dodge/charger/2025/oem/2025_dodge_charger_coupe_daytona-scat-pack_fq_oem_5_600.jpg',
  'toyota/sienna/2025':
    'toyota/sienna/2025/oem/2025_toyota_sienna_passenger-minivan_platinum-7-passenger_fq_oem_1_600.jpg',
  'honda/odyssey/2025': 'honda/odyssey/2025/oem/2025_honda_odyssey_passenger-minivan_elite_fq_oem_1_600.jpg',
  'kia/carnival-hybrid/2025':
    'kia/carnival-hybrid/2025/oem/2025_kia_carnival-hybrid_passenger-minivan_sx-prestige_fq_oem_1_600.jpg',
  'tesla/model-3/2025': 'tesla/model-3/2025/oem/2025_tesla_model-3_sedan_long-range_fq_oem_6_600.jpg',
  'hyundai/ioniq-6/2025': 'hyundai/ioniq-6/2025/oem/2025_hyundai_ioniq-6_sedan_limited_fq_oem_10_600.jpg',
  'fiat/500e/2025': 'fiat/500e/2025/oem/2025_fiat_500e_2dr-hatchback_giorgio-armani_fq_oem_6_600.jpg',
  'kia/ev9/2025': 'kia/ev9/2025/oem/2025_kia_ev9_4dr-suv_gt-line_fq_oem_15_600.jpg',
  'tesla/model-y/2026': 'tesla/model-y/2026/oem/2026_tesla_model-y_4dr-suv_long-range-launch-series_fq_oem_1_600.jpg',
  'volkswagen/id-buzz/2025':
    'volkswagen/id-buzz/2025/oem/2025_volkswagen_id-buzz_passenger-minivan_pro-s-plus_fq_oem_12_600.jpg',
  'rivian/r1t/2025': 'rivian/r1t/2025/oem/2025_rivian_r1t_crew-cab-pickup_california-dune_fq_oem_1_600.jpg',
  'ford/f-150-lightning/2025':
    'ford/f-150-lightning/2025/oem/2025_ford_f-150-lightning_crew-cab-pickup_lariat_fq_oem_2_600.jpg',
  'gmc/sierra-ev/2025': 'gmc/sierra-ev/2025/oem/2025_gmc_sierra-ev_crew-cab-pickup_denali-max-range_fq_oem_1_600.jpg',
  'ford/e-transit-cargo-van/2025':
    'ford/e-transit-cargo-van/2025/oem/2025_ford_e-transit-cargo-van_cargo-van_350-medium-roof_fq_oem_1_600.jpg',
  'bmw/i5/2025': 'bmw/i5/2025/oem/2025_bmw_i5_sedan_edrive40_fq_oem_10_600.jpg',
  'mercedes-benz/eqe/2025': 'mercedes-benz/eqe/2025/oem/2025_mercedes-benz_eqe_sedan_amg-eqe_fq_oem_6_600.jpg',
  'genesis/electrified-g80/2025':
    'genesis/electrified-g80/2025/oem/2025_genesis_electrified-g80_sedan_advanced_fq_oem_2_600.jpg',
  'bmw/ix/2025': 'bmw/ix/2025/oem/2025_bmw_ix_4dr-suv_m60_fq_oem_7_600.jpg',
  'genesis/electrified-gv70/2025':
    'genesis/electrified-gv70/2025/oem/2025_genesis_electrified-gv70_4dr-suv_advanced_fq_oem_1_600.jpg',
  'genesis/gv60/2025': 'genesis/gv60/2025/oem/2025_genesis_gv60_4dr-suv_performance_fq_oem_3_600.jpg',
  'bmw/i7/2025': 'bmw/i7/2025/oem/2025_bmw_i7_sedan_m70_fq_oem_3_600.jpg',
  'lucid/air/2025': 'lucid/air/2025/oem/2025_lucid_air_sedan_grand-touring_fq_oem_13_600.jpg',
  'rolls-royce/spectre/2024': 'rolls-royce/spectre/2024/oem/2024_rolls-royce_spectre_coupe_base_fq_oem_10_600.jpg',
  'mercedes-benz/eqs-suv/2025/eqs-450plus/2025':
    'mercedes-benz/eqs-suv/2025/oem/2025_mercedes-benz_eqs-suv_4dr-suv_eqs-450plus_fq_oem_3_600.jpg',
  'mercedes-benz/maybach-eqs-suv/2025':
    'mercedes-benz/maybach-eqs-suv/2025/oem/2025_mercedes-benz_maybach-eqs-suv_4dr-suv_eqs-680_fq_oem_2_600.jpg',
  'mercedes-benz/g-class/2025/electric':
    'mercedes-benz/g-class/2025/oem/2025_mercedes-benz_g-class_4dr-suv_g-580-weq-technology_fq_oem_3_600.jpg',
  'tesla/model-3/2025/performance': 'tesla/model-3/2025/oem/2025_tesla_model-3_sedan_performance_s_oem_3_600.jpg',
  'bmw/i4/2025/m50': 'bmw/i4/2025/oem/2025_bmw_i4_sedan_m50_fq_oem_3_600.jpg',
  'hyundai/ioniq-5-n/2025': 'hyundai/ioniq-5-n/2025/oem/2025_hyundai_ioniq-5-n_4dr-suv_base_fq_oem_1_600.jpg',
  'bmw/ix/2025/m60': 'bmw/ix/2025/oem/2025_bmw_ix_4dr-suv_m60_fq_oem_9_600.jpg',
  'ford/mustang-mach-e/2025/gt':
    'ford/mustang-mach-e/2025/oem/2025_ford_mustang-mach-e_4dr-hatchback_gt_fq_oem_2_600.jpg',
  'tesla/model-s/2025': 'tesla/model-s/2025/oem/2025_tesla_model-s_sedan_plaid_fq_oem_2_600.jpg',
  'mercedes-benz/eqe/2025/amg-eqe': 'mercedes-benz/eqe/2025/oem/2025_mercedes-benz_eqe_sedan_amg-eqe_fq_oem_3_600.jpg',
  'mercedes-benz/eqs/2025': 'mercedes-benz/eqs/2025/oem/2025_mercedes-benz_eqs_sedan_amg-eqs_fq_oem_12_600.jpg',
  'audi/a4-allroad/2025': 'audi/a4-allroad/2021/oem/2021_audi_a4-allroad_wagon_prestige_fq_oem_1_600.jpg',
  'volvo/v60-cross-country/2025':
    'volvo/v60-cross-country/2025/oem/2025_volvo_v60-cross-country_wagon_b5-ultra_fq_oem_1_600.jpg',
  'audi/a6-allroad/2025': 'audi/a6-allroad/2021/oem/2021_audi_a6-allroad_wagon_premium-plus_fq_oem_1_600.jpg',
  'volvo/v90-cross-country/2025':
    'volvo/v90-cross-country/2025/oem/2025_volvo_v90-cross-country_wagon_b6-ultra_fq_oem_1_600.jpg',
  'hyundai/santa-cruz/2025':
    'hyundai/santa-cruz/2025/oem/2025_hyundai_santa-cruz_crew-cab-pickup_limited_fq_oem_1_600.jpg',
  'ford/maverick/2025': 'ford/maverick/2025/oem/2025_ford_maverick_crew-cab-pickup_lariat_fq_oem_1_600.jpg',
  'ford/ranger/2025': 'ford/ranger/2025/oem/2025_ford_ranger_crew-cab-pickup_lariat_fq_oem_1_600.jpg',
  'chevrolet/colorado/2025':
    'chevrolet/colorado/2025/oem/2025_chevrolet_colorado_crew-cab-pickup_trail-boss_fq_oem_1_600.jpg',
  'gmc/canyon/2024': 'gmc/canyon/2023/oem/2023_gmc_canyon_crew-cab-pickup_at4_fq_oem_1_600.jpg',
  'gmc/canyon/2025': 'gmc/canyon/2025/oem/2025_gmc_canyon_crew-cab-pickup_at4_fq_oem_1_600.jpg',
  'ford/f-150/2025': 'ford/f-150/2025/oem/2025_ford_f-150_crew-cab-pickup_lariat_fq_oem_1_600.jpg',
  'ram/1500/2025': 'ram/1500/2025/oem/2025_ram_1500_crew-cab-pickup_rebel_fq_oem_1_600.jpg',
  'toyota/tundra/2025': 'toyota/tundra/2025/oem/2025_toyota_tundra_extended-cab-pickup_sr5_fq_oem_1_600.jpg',
  'ford/f-250-super-duty/2024':
    'ford/f-250-super-duty/2023/oem/2023_ford_f-250-super-duty_crew-cab-pickup_lariat_fq_oem_1_600.jpg',
  'ram/2500/2024': 'ram/2500/2023/oem/2023_ram_2500_regular-cab-pickup_tradesman_fq_oem_1_600.jpg',
  'chevrolet/silverado-2500hd/2025':
    'chevrolet/silverado-2500hd/2025/oem/2025_chevrolet_silverado-2500hd_crew-cab-pickup_high-country_fq_oem_1_600.jpg',
  'subaru/brz/2025': 'subaru/brz/2025/oem/2025_subaru_brz_coupe_limited_fq_oem_1_600.jpg',
  'toyota/gr86/2024': 'toyota/gr86/2024/oem/2024_toyota_gr86_coupe_base_fq_oem_1_600.jpg',
  'mercedes-benz/cle/2025/coupe': 'mercedes-benz/cle/2025/oem/2025_mercedes-benz_cle_coupe_amg-cle-53_fq_oem_1_600.jpg',
  'bmw/2-series/2025': 'bmw/2-series/2025/oem/2025_bmw_2-series_coupe_m240i_fq_oem_1_600.jpg',
  'bmw/4-series/2025/coupe': 'bmw/4-series/2025/oem/2025_bmw_4-series_coupe_m440i_fq_oem_1_600.jpg',
  'chevrolet/corvette/2025': 'chevrolet/corvette/2024/oem/2024_chevrolet_corvette_coupe_e-ray_fq_oem_1_600.jpg',
  'porsche/911/2025': 'porsche/911/2025/oem/2025_porsche_911_coupe_carrera-4-gts_fq_oem_1_600.jpg',
  'bmw/8-series/2025/coupe': 'bmw/8-series/2025/oem/2025_bmw_8-series_coupe_m850i-xdrive_fq_oem_1_600.jpg',
  'bentley/continental/2025/coupe':
    'bentley/continental/2025/oem/2025_bentley_continental_coupe_gt-black-edition_fq_oem_1_600.jpg',
  'chevrolet/corvette/2025/z06': 'chevrolet/corvette/2024/oem/2024_chevrolet_corvette_coupe_z06_fq_oem_1_600.jpg',
  'mercedes-benz/amg-gt/2025': 'mercedes-benz/amg-gt/2025/oem/2025_mercedes-benz_amg-gt_coupe_43_fq_oem_1_600.jpg',
  'porsche/911/2024/gt3': 'porsche/911/2024/oem/2024_porsche_911_coupe_gt3_fq_oem_1_600.jpg',
  'honda/civic/2025/hybrid':
    'honda/civic/2025/oem/2025_honda_civic_4dr-hatchback_sport-touring-hybrid_fq_oem_1_600.jpg',
  'toyota/camry/2025': 'toyota/camry/2025/oem/2025_toyota_camry_sedan_se_fq_oem_2_600.jpg',
  'toyota/prius/2025': 'toyota/prius/2025/oem/2025_toyota_prius_4dr-hatchback_limited_fq_oem_1_600.jpg',
  'toyota/prius-plug-in-hybrid/2025':
    'toyota/prius-plug-in-hybrid/2025/oem/2025_toyota_prius-plug-in-hybrid_4dr-hatchback_xse-premium_fq_oem_1_600.jpg',
  'hyundai/tucson-plug-in-hybrid/2025':
    'hyundai/tucson-plug-in-hybrid/2025/oem/2025_hyundai_tucson-plug-in-hybrid_4dr-suv_limited_fq_oem_1_600.jpg',
  'kia/niro-plug-in-hybrid/2025':
    'kia/niro-plug-in-hybrid/2025/oem/2025_kia_niro-plug-in-hybrid_4dr-suv_sx-touring_fq_oem_1_600.jpg',
  'mitsubishi/outlander-phev/2025':
    'mitsubishi/outlander-phev/2025/oem/2025_mitsubishi_outlander-phev_4dr-suv_es_fq_oem_1_600.jpg',
  'lexus/es/2025/hybrid': 'lexus/es/2025/oem/2025_lexus_es_sedan_300h-f-sport-design_fq_oem_1_600.jpg',
  'mercedes-benz/s-class/2025/plug-in-hybrid':
    'mercedes-benz/s-class/2025/oem/2025_mercedes-benz_s-class_sedan_s-580e-4matic_fq_oem_1_600.jpg',
  'volvo/s90/2025/plug-in-hybrid': 'volvo/s90/2025/oem/2025_volvo_s90_sedan_t8-ultra_fq_oem_1_600.jpg',
  'volvo/s60/2025/plug-in-hybrid': 'volvo/s60/2025/oem/2025_volvo_s60_sedan_t8-ultra_fq_oem_1_600.jpg',
  'mercedes-benz/gle-class/2025/plug-in-hybrid':
    'mercedes-benz/gle-class/2025/oem/2025_mercedes-benz_gle-class_4dr-suv_gle-450e_fq_oem_1_600.jpg',
  'volvo/xc60/2025/plug-in-hybrid': 'volvo/xc60/2025/oem/2025_volvo_xc60_4dr-suv_t8-plus_fq_oem_1_600.jpg',
  'bmw/x5/2025/plug-in-hybrid': 'bmw/x5/2025/oem/2025_bmw_x5_4dr-suv_xdrive50e_fq_oem_1_600.jpg',
  'nissan/versa/2025': 'nissan/versa/2025/oem/2025_nissan_versa_sedan_sr_fq_oem_1_600.jpg',
  'honda/civic/2025': 'honda/civic/2025/oem/2025_honda_civic_sedan_sport-touring-hybrid_fq_oem_1_600.jpg',
  'honda/civic/2025/sedan': 'honda/civic/2025/oem/2025_honda_civic_sedan_sport-touring-hybrid_fq_oem_1_600.jpg',
  'kia/k4/2025': 'kia/k4/2025/oem/2025_kia_k4_sedan_gt-line-turbo_fq_oem_4_600.jpg',
  'kia/forte/2024': 'kia/forte/2022/oem/2022_kia_forte_sedan_gt_fq_oem_1_600.jpg',
  'kia/forte/2024/sedan': 'kia/forte/2022/oem/2022_kia_forte_sedan_gt_fq_oem_1_600.jpg',
  'honda/accord/2025': 'honda/accord/2025/oem/2025_honda_accord_sedan_sport-l-hybrid_fq_oem_2_600.jpg',
  'kia/k5/2025': 'kia/k5/2025/oem/2025_kia_k5_sedan_gt_fq_oem_2_600.jpg',
  'toyota/crown/2025': 'toyota/crown/2025/oem/2025_toyota_crown_sedan_limited_fq_oem_2_600.jpg',
  'audi/a3/2025': 'audi/a3/2025/oem/2025_audi_a3_sedan_premium-plus_fq_oem_1_600.jpg',
  'audi/a3/2025/sedan': 'audi/a3/2025/oem/2025_audi_a3_sedan_premium-plus_fq_oem_1_600.jpg',
  'bmw/2-series-gran-coupe/2024':
    'bmw/2-series-gran-coupe/2020/oem/2020_bmw_2-series-gran-coupe_sedan_228i-xdrive_fq_oem_5_600.jpg',
  'mercedes-benz/cla-class/2025':
    'mercedes-benz/cla-class/2025/oem/2025_mercedes-benz_cla-class_sedan_cla-250_fq_oem_2_600.jpg',
  'bmw/3-series/2025': 'bmw/3-series/2025/oem/2025_bmw_3-series_sedan_330i_fq_oem_1_600.jpg',
  'mercedes-benz/c-class/2025':
    'mercedes-benz/c-class/2025/oem/2025_mercedes-benz_c-class_sedan_amg-c-43_fq_oem_7_600.jpg',
  'audi/a4/2025': 'audi/a4/2022/oem/2022_audi_a4_sedan_prestige-s-line_fq_oem_8_600.jpg',
  'mercedes-benz/e-class/2025':
    'mercedes-benz/e-class/2025/oem/2025_mercedes-benz_e-class_sedan_e-350-4matic_fq_oem_1_600.jpg',
  'bmw/5-series/2025': 'bmw/5-series/2025/oem/2025_bmw_5-series_sedan_530i_fq_oem_1_600.jpg',
  'volvo/s90/2025': 'volvo/s90/2025/oem/2025_volvo_s90_sedan_t8-ultra_fq_oem_1_600.jpg',
  'mercedes-benz/s-class/2025':
    'mercedes-benz/s-class/2025/oem/2025_mercedes-benz_s-class_sedan_s-500-4matic_fq_oem_3_600.jpg',
  'genesis/g90/2025': 'genesis/g90/2025/oem/2025_genesis_g90_sedan_35t-e-supercharger_fq_oem_1_600.jpg',
  'bmw/7-series/2025': 'bmw/7-series/2025/oem/2025_bmw_7-series_sedan_760i-xdrive_fq_oem_15_600.jpg',
  'bentley/flying-spur/2024':
    'bentley/flying-spur/2024/oem/2024_bentley_flying-spur_sedan_azure-hybrid_fq_oem_5_600.jpg',
  'hyundai/elantra-n/2025': 'hyundai/elantra-n/2025/oem/2025_hyundai_elantra-n_sedan_base_fq_oem_1_600.jpg',
  'honda/civic/2025/si': 'honda/civic/2025/oem/2025_honda_civic_sedan_si_fq_oem_4_600.jpg',
  'volkswagen/jetta-gli/2025':
    'volkswagen/jetta-gli/2025/oem/2025_volkswagen_jetta-gli_sedan_autobahn_fq_oem_1_600.jpg',
  'acura/integra/2025/type-s': 'acura/integra/2025/oem/2025_acura_integra_4dr-hatchback_type-s_fq_oem_5_600.jpg',
  'audi/s3/2025': 'audi/s3/2025/oem/2025_audi_s3_sedan_prestige_fq_oem_10_600.jpg',
  'audi/rs-3/2024': 'audi/rs-3/2022/oem/2022_audi_rs-3_sedan_base_s_oem_1_600.jpg',
  'audi/rs-6/2025': 'audi/rs-6/2025/oem/2025_audi_rs-6_wagon_performance_fq_oem_4_600.jpg',
  'audi/rs-7/2025': 'audi/rs-7/2025/oem/2025_audi_rs-7_sedan_performance_fq_oem_1_600.jpg',
  'cadillac/ct5/2025/v-blackwing/2025': 'cadillac/ct5/2025/oem/2025_cadillac_ct5_sedan_v-blackwing_fq_oem_1_600.jpg',
  'bmw/alpina-b8-gran-coupe/2024':
    'bmw/alpina-b8-gran-coupe/2023/oem/2023_bmw_alpina-b8-gran-coupe_sedan_base_fq_oem_2_600.jpg',
  'audi/s8/2025': 'audi/s8/2022/oem/2022_audi_s8_sedan_base_fq_oem_2_600.jpg',
  'bmw/m8-gran-coupe/2025': 'bmw/m8-gran-coupe/2025/oem/2025_bmw_m8-gran-coupe_sedan_competition_fq_oem_2_600.jpg',
  'honda/civic/2025/hatchback':
    'honda/civic/2025/oem/2025_honda_civic_4dr-hatchback_sport-touring-hybrid_fq_oem_1_600.jpg',
  'mazda/3/2025/hatchback': 'mazda/3/2025/oem/2025_mazda_3_4dr-hatchback_25-s-carbon-edition_fq_oem_1_600.jpg',
  'subaru/impreza/2025': 'subaru/impreza/2025/oem/2025_subaru_impreza_4dr-hatchback_rs_fq_oem_1_600.jpg',
  'subaru/impreza/2025/hatchback': 'subaru/impreza/2025/oem/2025_subaru_impreza_4dr-hatchback_rs_fq_oem_1_600.jpg',
  'honda/civic/2025/type-r': 'honda/civic/2025/oem/2025_honda_civic_4dr-hatchback_type-r_fq_oem_1_600.jpg',
  'volkswagen/golf-r/2024': 'volkswagen/golf-r/2023/oem/2023_volkswagen_golf-r_4dr-hatchback_base_fq_oem_1_600.jpg',
  'volkswagen/golf-gti/2024':
    'volkswagen/golf-gti/2024/oem/2024_volkswagen_golf-gti_4dr-hatchback_380-autobahn_fq_oem_1_600.jpg',
  'ford/mustang/2025/convertible': 'ford/mustang/2025/oem/2025_ford_mustang_convertible_gt-premium_fq_oem_1_600.jpg',
  'mazda/mx-5-miata/2025':
    'mazda/mx-5-miata/2025/oem/2025_mazda_mx-5-miata_convertible_35th-anniversary_fq_oem_1_600.jpg',
  'mazda/mx-5-miata-rf/2025':
    'mazda/mx-5-miata-rf/2025/oem/2025_mazda_mx-5-miata-rf_convertible_grand-touring_fq_oem_1_600.jpg',
  'mercedes-benz/glb-class/2020':
    'mercedes-benz/glb-class/2020/oem/2020_mercedes-benz_glb-class_4dr-suv_glb-250-4matic_fq_oem_1_600.jpg',
  'hyundai/tucson/2025/hybrid': 'hyundai/tucson/2025/oem/2025_hyundai_tucson_4dr-suv_limited_fq_oem_1_600.jpg',
  'kia/sportage-hybrid/2025': 'kia/sportage-hybrid/2025/oem/2025_kia_sportage-hybrid_4dr-suv_ex_fq_oem_1_600.jpg',
};
export const REPLACE_WITH_FETCHPRIORITY = [
  'chevrolet/trailblazer/2025',
  'mazda/cx-30/2025',
  'buick/encore-gx/2025',
  'mazda/cx-50/2025',
  'honda/cr-v/2025',
  'mazda/cx-5/2025',
  'kia/sorento/2025',
  'hyundai/santa-fe/2025',
  'mitsubishi/outlander/2024',
  'honda/passport/2025',
  'toyota/land-cruiser/2025',
  'jeep/grand-cherokee/2025',
  'kia/telluride/2025',
  'hyundai/palisade/2025',
  'toyota/grand-highlander-hybrid/2025',
  'toyota/grand-highlander/2024',
  'gmc/yukon/2024',
  'chevrolet/suburban/2025',
  'ford/expedition/2024',
  'bmw/x1/2025',
  'mercedes-benz/glb-class/2025',
  'mercedes-benz/gla-class/2025',
  'genesis/gv70/2025',
  'mercedes-benz/glc-class/2025',
  'acura/rdx/2025',
  'mercedes-benz/gle-class/2025',
  'porsche/cayenne/2025',
  'genesis/gv80-coupe/2025',
  'lexus/gx/2025',
  'audi/q7/2025',
  'acura/mdx/2025',
  'mercedes-benz/gls-class/2025',
  'lincoln/navigator/2024',
  'bmw/x7/2025',
  'mercedes-benz/maybach-gls/2025',
  'bentley/bentayga/2024',
  'land-rover/range-rover/2025',
  'tesla/model-y/2025',
  'audi/sq5/2025',
  'audi/sq5-sportback/2025',
  'porsche/cayenne-coupe/2025/turbo-gt',
  'lamborghini/urus/2024',
  'audi/sq7/2025',
  'mercedes-benz/gls-class/2025/amg-gls-63',
  'bmw/alpina-xb7/2025',
  'cadillac/escalade/2024/v',
  'ford/mustang/2025/dark-horse',
  'ford/mustang/2025',
  'dodge/charger/2025',
  'toyota/sienna/2025',
  'honda/odyssey/2025',
  'kia/carnival-hybrid/2025',
  'tesla/model-3/2025',
  'hyundai/ioniq-6/2025',
  'fiat/500e/2025',
  'kia/ev9/2025',
  'tesla/model-y/2026',
  'volkswagen/id-buzz/2025',
  'rivian/r1t/2025',
  'ford/f-150-lightning/2025',
  'gmc/sierra-ev/2025',
  'ford/e-transit-cargo-van/2025',
  'bmw/i5/2025',
  'mercedes-benz/eqe/2025',
  'genesis/electrified-g80/2025',
  'bmw/ix/2025',
  'genesis/electrified-gv70/2025',
  'genesis/gv60/2025',
  'bmw/i7/2025',
  'lucid/air/2025',
  'rolls-royce/spectre/2024',
  'mercedes-benz/eqs-suv/2025/eqs-450plus/2025',
  'mercedes-benz/maybach-eqs-suv/2025',
  'mercedes-benz/g-class/2025/electric',
  'tesla/model-3/2025/performance',
  'bmw/i4/2025/m50',
  'hyundai/ioniq-5-n/2025',
  'bmw/ix/2025/m60',
  'ford/mustang-mach-e/2025/gt',
  'tesla/model-s/2025',
  'mercedes-benz/eqe/2025/amg-eqe',
  'mercedes-benz/eqs/2025',
  'audi/a4-allroad/2025',
  'volvo/v60-cross-country/2025',
  'audi/a6-allroad/2025',
  'volvo/v90-cross-country/2025',
  'hyundai/santa-cruz/2025',
  'ford/maverick/2025',
  'ford/ranger/2025',
  'chevrolet/colorado/2025',
  'gmc/canyon/2024',
  'ford/f-150/2025',
  'ram/1500/2025',
  'toyota/tundra/2025',
  'ford/f-250-super-duty/2024',
  'ram/2500/2024',
  'chevrolet/silverado-2500hd/2025',
  'subaru/brz/2025',
  'toyota/gr86/2024',
  'mercedes-benz/cle/2025/coupe',
  'bmw/2-series/2025',
  'bmw/4-series/2025/coupe',
  'chevrolet/corvette/2025',
  'porsche/911/2025',
  'bmw/8-series/2025/coupe',
  'bentley/continental/2025/coupe',
  'chevrolet/corvette/2025/z06',
  'mercedes-benz/amg-gt/2025',
  'porsche/911/2024/gt3',
  'honda/civic/2025/hybrid',
  'toyota/camry/2025',
  'toyota/prius/2025',
  'toyota/prius-plug-in-hybrid/2025',
  'hyundai/tucson-plug-in-hybrid/2025',
  'kia/niro-plug-in-hybrid/2025',
  'mitsubishi/outlander-phev/2025',
  'lexus/es/2025/hybrid',
  'mercedes-benz/s-class/2025/plug-in-hybrid',
  'volvo/s90/2025/plug-in-hybrid',
  'volvo/s60/2025/plug-in-hybrid',
  'mercedes-benz/gle-class/2025/plug-in-hybrid',
  'volvo/xc60/2025/plug-in-hybrid',
  'bmw/x5/2025/plug-in-hybrid',
  'nissan/versa/2025',
  'honda/civic/2025',
  'honda/civic/2025/sedan',
  'kia/k4/2025',
  'kia/forte/2024',
  'honda/accord/2025',
  'kia/k5/2025',
  'toyota/crown/2025',
  'audi/a3/2025',
  'audi/a3/2025/sedan',
  'bmw/2-series-gran-coupe/2024',
  'mercedes-benz/cla-class/2025',
  'bmw/3-series/2025',
  'mercedes-benz/c-class/2025',
  'audi/a4/2025',
  'mercedes-benz/e-class/2025',
  'bmw/5-series/2025',
  'volvo/s90/2025',
  'mercedes-benz/s-class/2025',
  'genesis/g90/2025',
  'bmw/7-series/2025',
  'bentley/flying-spur/2024',
  'hyundai/elantra-n/2025',
  'honda/civic/2025/si',
  'volkswagen/jetta-gli/2025',
  'acura/integra/2025/type-s',
  'audi/s3/2025',
  'audi/rs-3/2024',
  'audi/rs-6/2025',
  'audi/rs-7/2025',
  'cadillac/ct5/2025/v-blackwing/2025',
  'bmw/alpina-b8-gran-coupe/2024',
  'audi/s8/2025',
  'bmw/m8-gran-coupe/2025',
  'honda/civic/2025/hatchback',
  'mazda/3/2025/hatchback',
  'subaru/impreza/2025',
  'honda/civic/2025/type-r',
  'volkswagen/golf-r/2024',
  'volkswagen/golf-gti/2024',
  'ford/mustang/2025/convertible',
  'mazda/mx-5-miata/2025',
  'mazda/mx-5-miata-rf/2025',
  'mercedes-benz/glb-class/2020',
];
export const REPLACE_TYPES = [
  'electric',
  'electric-car',
  'suv',
  'hybrid',
  'truck',
  'sedan',
  'minivan',
  'crossover',
  'hatchback',
  'coupe',
  'convertible',
  'wagon',
  'economy',
  'muscle',
  'midsize',
  'sports-car',
  'compact',
  'subcompact',
  'exotic',
  'luxury',
];
